import $ from "jquery";
import m, {Vnode} from "mithril";
import {LabelItem} from "../../../../model/items/labelItem";

export default class StarsCell {

    private enabled: boolean = true;
    private visible: boolean = true;

    private hoverRating: number|null = null;

    constructor(
        private readonly starCount: number,
        private readonly maxRating: number,
        private readonly getVariable: () => number|null,
        private readonly setVariable: (rating: number) => void,
        private readonly labels: LabelItem[] = [],
    ) {
    }

    public get value(): number|null {
        return this.getVariable();
    }

    public setEnabled(enabled: boolean): StarsCell {
        this.enabled = enabled;
        return this;
    }

    public setVisible(visible: boolean): StarsCell {
        this.visible = visible;
        return this;
    }

    protected createStarsRatingElement(): Vnode {
        const starsEls = [];

        for (let i = 1; i <= this.starCount; i++) {
            starsEls.push(this.starView(i));
        }

        return m('.stars', {
            onmousemove: (e: MouseEvent) => this.hoverRating = this.calculateRating(e.pageX, $(e.currentTarget!)),
            onmouseleave: () => this.hoverRating = null,
            ontouchmove: (e: TouchEvent) => {
                e.preventDefault();
                this.calculateRating(e.touches[0].pageX, $(e.currentTarget!));
            },
            onclick: (e: MouseEvent) => this.setVariable( this.calculateRating(e.pageX, $(e.currentTarget!)) ),
        }, [
            m('.stars-foreground', {}, starsEls),
        ]);
    }

    private calculateRating(pageX: number, starsContainer: JQuery): number {
        const x = pageX - starsContainer.offset().left;
        const ratingWidth = starsContainer.innerWidth() / this.maxRating;
        return Math.min(Math.max(Math.floor(x/ratingWidth + 1) , 1), this.maxRating );
    }

    private starIndexToGradient(starIndex: number, value: number|null): number {
        const starsValue = this.starCount / this.maxRating * (value ?? 0);

        if (starIndex <= Math.floor(starsValue)) {
            return 1;
        }
        if (starIndex > Math.ceil(starsValue)) {
            return 0;
        }

        return starsValue - Math.floor(starsValue);
    }

    protected starView(starIndex: number) {
        const hoverThreshold = this.hoverRating ? this.starIndexToGradient(starIndex, this.hoverRating) : 0;
        const hovered = hoverThreshold===1 ? '.hovered' : '';
        const notHovered = hoverThreshold===0 ? '.not-hovered' : '';
        const hoverGradient = Boolean(!hovered && !notHovered);

        const threshold = this.starIndexToGradient(starIndex, this.value);
        const selected = threshold===1 ? '.selected' : '';
        const notSelected = threshold===0 ? '.not-selected' : '';
        const gradient = Boolean(!selected && !notSelected);

        const gradientColor = hoverGradient ? '--star-hover' : '--star-selected';

        return m('.star'+selected+notSelected+hovered+notHovered, {
            style: {
                paddingBottom: 100/this.starCount + '%',
                backgroundImage: (hoverGradient || gradient) ? `linear-gradient(to right, var(${gradientColor}) ${threshold*100}%, var(--star-not-selected) ${threshold*100}%, var(--star-not-selected))` : 'none',
                backgroundColor: (hoverGradient || gradient) ? 'var(--star-not-selected)' : '',
            }
        });
    }

    private labelView(label?: LabelItem): Vnode|null {
        if (!label) {
            return null;
        }
        const questionary = label.cell.grid.questionary;
        const text = label.childrenTags.filter(t => t.tag === 'text')[0]?.value;
        return m('.', {}, m.trust(questionary.renderText(text ? text : '')));
    }

    public view(): Vnode {

        return m('.StarsCell', {}, [
            m('.stars-labels-wrapper'+(this.enabled?'':'.disabled'), {}, this.visible ? [
                this.createStarsRatingElement(),
                this.labels.length ? m('.labels', {}, this.labels.map(l => this.labelView(l))) : null,
            ] : null)
        ])
    }

}